import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import { getUserDisplayName, hasPagePermission } from '../authStorage';
import { useT } from '../i18n/translations';
import './Sidebar.css';
import logo from '../assets/logo.png';

const NAV_GROUPS = [
  {
    sectionKey: 'nav.home',
    items: [
      { to: '/officer/dashboard',          labelKey: 'nav.officerDashboard',  icon: 'dashboard',   moduleId: 'dashboard'         },
      { to: '/officer/board',              labelKey: 'nav.board',             icon: 'board',       moduleId: 'board'             },
      { to: '/officer/unified-matrix',     labelKey: 'nav.unifiedMatrix',     icon: 'report',      moduleId: 'unified_matrix'    },
    ],
  },
  {
    sectionKey: 'nav.management',
    items: [
      { to: '/officer/shareholders',       labelKey: 'nav.shareholders',      icon: 'money',       moduleId: 'shareholders'      },
      { to: '/officer/departments',        labelKey: 'nav.departments',       icon: 'board',       moduleId: 'departments'       },
      { to: '/officer/operational-plans',  labelKey: 'nav.plans',             icon: 'report',      moduleId: 'operational_plans' },
      { to: '/officer/committees',         labelKey: 'nav.committees',        icon: 'board',       moduleId: 'committees'        },
    ],
  },
  {
    sectionKey: 'common.decisions',
    items: [
      { to: '/officer/tasks',              labelKey: 'nav.taskManagement',    icon: 'settings'                                   },
      { to: '/officer/meetings',           labelKey: 'common.meetings',       icon: 'calendar'                                   },
      { to: '/officer/decision-types',     labelKey: 'nav.decisionTypes',     icon: 'decisions',   moduleId: 'decision_types'    },
      { to: '/officer/decisions',          labelKey: 'common.decisions',      icon: 'decisions',   moduleId: 'decisions'         },
      { to: '/officer/branches',           labelKey: 'nav.branches',          icon: 'branch',      moduleId: 'branches'          },
    ],
  },
  {
    sectionKey: 'nav.system',
    items: [
      { to: '/officer/permissions',        labelKey: 'nav.myPermissions',     icon: 'lock',        moduleId: 'permissions'       },
      { to: '/officer/settings',           labelKey: 'common.settings',       icon: 'settings'                                   },
    ],
  },
];

export default function OfficerSidebar({ isOpen, onClose }) {
  const t = useT();
  const [collapsed, setCollapsed] = useState(false);
  const displayName = getUserDisplayName() || t('common.user');

  return (
    <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}${isOpen ? ' sidebar--mobile-open' : ''}`}>
      <div className="sidebar__brand">
        <img src={logo} alt={t('common.brand')} className="sidebar__brand-logo" />
        <div className="sidebar__brand-text">
          <div className="sidebar__brand-name">{t('common.brand')}</div>
          <div className="sidebar__brand-tagline">{t('nav.officerTagline')}</div>
        </div>
        <button className="sidebar__mobile-close" onClick={onClose} aria-label={t('common.closeMenu')}>
          <Icon name="x-circle" size={18} color="rgba(255,255,255,0.7)" />
        </button>
      </div>

      <div className="sidebar__user">
        <div className="sidebar__user-avatar">أس</div>
        <div className="sidebar__user-info">
          <div className="sidebar__user-name">{displayName}</div>
          <div className="sidebar__user-role">{t('nav.systemUser')}</div>
        </div>
        <span className="sidebar__user-dot" />
      </div>

      <nav className="sidebar__nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.sectionKey}>
            <div className="sidebar__section-title">{t(group.sectionKey)}</div>
            {group.items.filter((item) => !item.moduleId || hasPagePermission(item.moduleId)).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `sidebar__item${isActive ? ' sidebar__item--active' : ''}`}
                data-label={t(item.labelKey)}
              >
                <span className="sidebar__item-icon">
                  <Icon name={item.icon} size={18} color="rgba(255,255,255,0.85)" />
                </span>
                <span className="sidebar__item-label">{t(item.labelKey)}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <button className="sidebar__toggle" onClick={() => setCollapsed(!collapsed)}>
        <span className="sidebar__toggle-icon">
          <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} size={15} color="rgba(255,255,255,0.5)" />
        </span>
        <span className="sidebar__toggle-label">{t('common.collapseMenu')}</span>
      </button>
    </aside>
  );
}
